import React from "react";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
import Home from "./home/Home";
import Members from "./members/Members";
import Products from "./products/Products";
import Login from "../components/auth/Login";
import RentRequest from "./rentRequests/RentRequest";

const BodyRouter = (props) => {
  return (
    <div>
      <Switch>
        <Route exact path="/" component={Home}>
          <Home />
        </Route>
        <Route
          exact
          path="/members"
          render={(routerProps) => {
            if (sessionStorage.getItem("token")) {
              return <Members routerProps={routerProps} />;
            } else {
              return <Login routerProps={routerProps} />;
            }
          }}
        />
        <Route exact path="/products" component={Products}>
          <Products />
        </Route>
        <Route exact path="/rent-requests" component={RentRequest}>
          <RentRequest />
        </Route>
      </Switch>
    </div>
  );
};

export default BodyRouter;
